import { useEffect, useState } from "react";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { getUserISO, CountryPickerValue } from "@jugl-web/ui-kit";
import countries from "countries-phone-masks";

export const useDefaultCountry = () => {
  const { authApi } = useRestApiProvider();
  const { data: countryCode } = authApi.useRequestCountryQuery({
    meta: { silent: true },
  });
  const [defaultCountry, setDefaultCountry] = useState<CountryPickerValue>();

  useEffect(() => {
    if (defaultCountry) return;

    const iso =
      countryCode?.country && countryCode.country !== "default"
        ? countryCode.country
        : getUserISO();

    const found = countries.find((c: CountryPickerValue) => c.iso === iso);
    if (found) {
      setDefaultCountry(found);
    }
  }, [countryCode, defaultCountry]);

  return defaultCountry;
};
